import {NgModule} from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {AssetOverviewPageComponent} from "./asset-overview-page/asset-overview-page.component";
import {AssetDetailsPageComponent} from "./asset-details-page/asset-details-page.component";
import {SharedModule} from "../shared/shared.module";
import {MatIconModule} from "@angular/material/icon";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule} from "@angular/material/list";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatInputModule} from "@angular/material/input";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {AssetDescriptionComponent} from "./asset-details-page/asset-description/asset-description.component";
import {AssetGeneralInformationComponent} from "./asset-details-page/asset-general-information/asset-general-information.component";
import {AssetEndMarketsCustomersComponent} from "./asset-details-page/asset-end-markets-customers/asset-end-markets-customers.component";
import {AssetSwotComponent} from "./asset-details-page/asset-swot/asset-swot.component";
import {AssetExitInformationComponent} from "./asset-details-page/asset-exit-information/asset-exit-information.component";
import {AssetGpValuationComponent} from "./asset-details-page/asset-gp-valuation/asset-gp-valuation.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatChipsModule} from "@angular/material/chips";
import {MatTableModule} from "@angular/material/table";
import {AssetFinDataHistoryComponent} from "./asset-details-page/asset-fin-data-history/asset-fin-data-history.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatExpansionModule} from "@angular/material/expansion";
import {AssetNewDialogComponent} from "./asset-new-dialog/asset-new-dialog.component";
import {MatDialogModule} from "@angular/material/dialog";
import {AssetDiscountMultipleValuationComponent} from "./asset-details-page/asset-valuation-forecast/asset-discount-multiple-valuation/asset-discount-multiple-valuation.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatRadioModule} from "@angular/material/radio";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {AssetHistoryPeriodDialogComponent} from "./asset-details-page/asset-fin-data-history/asset-history-period-dialog/asset-history-period-dialog.component";
import {AssetShareholderStructureComponent} from "./asset-details-page/asset-shareholder-structure/asset-shareholder-structure.component";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {SearchModule} from "../search/search.module";
import {BASE_PATH} from "./generated-sources/api";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatTabsModule} from "@angular/material/tabs";
import {AssetValuationForecastComponent} from "./asset-details-page/asset-valuation-forecast/asset-valuation-forecast.component";
import {
    AssetFinancialOperationalValuationComponent
} from "./asset-details-page/asset-valuation-forecast/asset-operational-valuation/asset-financial-operational-valuation.component";
import {MatMenuModule} from "@angular/material/menu";
import {AssetFinDataHistoryTableComponent} from "./asset-details-page/asset-fin-data-history/asset-fin-data-history-table/asset-fin-data-history-table.component";
import {
    AssetFinancialOperationalValuationScenarioComponent
} from "./asset-details-page/asset-valuation-forecast/asset-operational-valuation/asset-operational-valuation-scenario/asset-financial-operational-valuation-scenario.component";
import {AssetValuationRationaleComponent} from "./asset-details-page/asset-valuation-forecast/asset-valuation-rationale/asset-valuation-rationale.component";
import {AssetCashflowNewDialogComponent} from "./asset-details-page/asset-valuation-forecast/asset-cashflow-new-dialog/asset-cashflow-new-dialog.component";
/* eslint-disable max-len */
import {AssetHistoryBaseCustomDialogComponent} from "./asset-details-page/asset-valuation-forecast/asset-operational-valuation/asset-history-base-custom-dialog/asset-history-base-custom-dialog.component";
import {
    AssetFinancialOperationalValuationTableComponent
} from "./asset-details-page/asset-valuation-forecast/asset-operational-valuation/asset-operational-valuation-scenario/asset-financial-operational-valuation-table/asset-financial-operational-valuation-table.component";
import {RouterModule} from "@angular/router";
import {AssetComparableCompaniesComponent} from "./asset-details-page/asset-comparable-companies/asset-comparable-companies.component";
import {QuickForecastComponent} from "./asset-details-page/asset-valuation-forecast/asset-operational-valuation/quick-forecast/quick-forecast.component";
import {ContextMenuComponent} from "../shared/components/context-menu/context-menu.component";
import {
    AssetDevelopmentsSinceInvestmentComponent
} from "./asset-details-page/asset-developments-since-investment/asset-developments-since-investment.component";
/* eslint-enable max-len */

@NgModule({
    declarations: [
        AssetOverviewPageComponent,
        AssetDetailsPageComponent,
        AssetDescriptionComponent,
        AssetGeneralInformationComponent,
        AssetEndMarketsCustomersComponent,
        AssetSwotComponent,
        AssetExitInformationComponent,
        AssetGpValuationComponent,
        AssetFinDataHistoryComponent,
        AssetNewDialogComponent,
        AssetDiscountMultipleValuationComponent,
        AssetHistoryPeriodDialogComponent,
        AssetShareholderStructureComponent,
        AssetValuationForecastComponent,
        AssetFinancialOperationalValuationComponent,
        AssetFinDataHistoryTableComponent,
        AssetFinancialOperationalValuationScenarioComponent,
        AssetValuationRationaleComponent,
        AssetCashflowNewDialogComponent,
        AssetHistoryBaseCustomDialogComponent,
        AssetFinancialOperationalValuationTableComponent
    ],
    exports: [
        AssetGeneralInformationComponent,
        AssetGpValuationComponent,
        AssetDiscountMultipleValuationComponent,
        AssetExitInformationComponent,
        AssetFinancialOperationalValuationComponent,
        AssetFinancialOperationalValuationTableComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatCardModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatTableModule,
        MatToolbarModule,
        ReactiveFormsModule,
        SharedModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatRadioModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatSortModule,
        NgOptimizedImage,
        SearchModule,
        MatTabsModule,
        MatTooltipModule,
        MatMenuModule,
        SearchModule,
        AssetComparableCompaniesComponent,
        AssetDevelopmentsSinceInvestmentComponent,
        QuickForecastComponent,
        ContextMenuComponent
    ],
    providers: [
        {provide: BASE_PATH, useValue: ".."}
    ]
})
export class AssetModule {
}
